module.exports = __webpack_public_path__ + "img/favicon.fd562679.png";